/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { EditMyCriteriaFieldWrapper } from 'Components/widgets/edit-my-criteria/criteria/EditMyCriteriaFieldWrapper';
import { popinsActions } from 'Components/widgets/booking-breadcrumb/headerPopins.reducer';
import type { CriteriaForSearch } from 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
import 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
type CriteriaWithPopOverPropsType = {
  selectorComponent: Node;
  popOverComponent: Node;
  blockBeforeValidateComponent?: Node;
  selectedProposal: Proposal;
  criteria: CriteriaForSearch;
  setNewCriteria: (arg0: CriteriaForSearch) => void;
  newCriteria: CriteriaForSearch;
  dispatchPopin: (arg0: any) => void;
  onClickTracking: (arg0: any) => void;
  validateButtonCriteriaSelectorTracking?: (arg0: any) => void;
  i18n: CMSContent;
};

const areEqualCriteria = (criteria, newCriteria) => {
  const criteriaString = JSON.stringify(criteria, null, 2);
  const newCriteriaString = JSON.stringify(newCriteria, null, 2);
  return criteriaString === newCriteriaString;
};

export const CriteriaWithPopOver = ({
  selectorComponent: SelectorComponent,
  popOverComponent: PopOverComponent,
  blockBeforeValidateComponent: BlockBeforeValidateComponent,
  selectedProposal,
  criteria,
  setNewCriteria,
  newCriteria,
  dispatchPopin,
  onClickTracking,
  validateButtonCriteriaSelectorTracking,
  i18n,
}: CriteriaWithPopOverPropsType) => {
  const shouldDisableValidateButton = areEqualCriteria(criteria, newCriteria);

  const PopOverContent = () => {
    return (
      <PopOverComponent
        criteria={criteria}
        setNewCriteria={setNewCriteria}
        newCriteria={newCriteria}
        i18n={i18n}
      />
    );
  };

  return (
    <EditMyCriteriaFieldWrapper
      toggleEditCriteria={(isExpanded) => {
        !isExpanded && setNewCriteria({ ...criteria });
      }}
      disableValidateButton={shouldDisableValidateButton}
      trackCriteriaClick={onClickTracking}
      openByDefault={false}
      triggerComponent={
        <SelectorComponent
          newCriteria={newCriteria}
          criteria={criteria}
          selectedProposal={selectedProposal}
        />
      }
      dataTestId="EditMyCriteriaFieldWrapper"
      updateCriteria={() => {
        !!validateButtonCriteriaSelectorTracking && validateButtonCriteriaSelectorTracking();
        dispatchPopin({
          type: popinsActions.CRITERIA_CONFIRMATION_OPEN,
        });
      }}
    >
      <div>
        <PopOverContent newCriteria={newCriteria} />
        {!!BlockBeforeValidateComponent && <BlockBeforeValidateComponent />}
      </div>
    </EditMyCriteriaFieldWrapper>
  );
};
